// EntitlementsLayout — shared chrome for the /admin/entitlements/* subtree.
// Provides the sidebar nav and gates the whole subtree on the `tenant-admin`
// Cognito group via userStore.isTenantAdmin.
//
// Slice-1-only pages (Dashboard, Entitlements) are live; the rest are stubs
// that render a "coming with slice N" placeholder so the nav reads complete.

import {inject, observer} from "mobx-react";
import {Outlet, NavLink} from "react-router-dom";

import {withAuthentication} from "../../components/AuthenticateUser";
import "./AdminEntitlements.css";

const NAV = [
  { to: "/admin/entitlements",            label: "Dashboard",    end: true },
  { to: "/admin/entitlements/skus",       label: "Entitlements"           },
  { to: "/admin/entitlements/users",      label: "Users"                  },
  { to: "/admin/entitlements/usage",      label: "Usage"                  },
  { to: "/admin/entitlements/contracts",  label: "Contracts"              },
  { to: "/admin/entitlements/teams",      label: "Teams"                  },
  { to: "/admin/entitlements/audit",      label: "Audit"                  },
];

const EntitlementsLayout = ({userStore}) => {
  // Soft gate: render an informational panel instead of redirecting, so an
  // admin who shares the URL with a teammate gets a sensible message rather
  // than a silent bounce to root.
  if (!userStore.isTenantAdmin && !userStore.isAdmin) {
    return (
      <div className="adminEnt stone-page">
        <div className="gate">
          <h2>Tenant administrators only</h2>
          <p>
            This area manages your organization's Plex entitlements — seat
            assignments, usage, and contracts.
          </p>
          <p style={{marginTop: 12}}>
            Ask your tenant administrator to add you to the
            <strong> tenant-admin </strong>
            group if you need access.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="adminEnt stone-page">
      <div className="adminEnt-shell">
        <aside className="adminEnt-sidebar" aria-label="Entitlements administration">
          <div className="sidebar-group">
            <h5>Administration</h5>
            {NAV.map(({to, label, end}) => (
              <NavLink
                key={to}
                to={to}
                end={end}
                className={({isActive}) => isActive ? "active" : undefined}
              >
                {label}
              </NavLink>
            ))}
          </div>
        </aside>
        <main className="adminEnt-page">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default withAuthentication(inject("userStore")(observer(EntitlementsLayout)));
